import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

@vsingleton()
export class AdminDepositBankAccountRoute extends RouteBase {
  prefix = 'admin.financial.deposit-bank-accounts.'

  index() {
    return this.ziggyRoute('index')
  }

  create() {
    return this.ziggyRoute('create')
  }

  store() {
    return this.ziggyRoute('store')
  }

  show(accountId: number) {
    return this.ziggyRoute('show', accountId)
  }

  edit(accountId: number) {
    return this.ziggyRoute('edit', accountId)
  }

  update(accountId: number) {
    return this.ziggyRoute('update', accountId)
  }
}
